import React from 'react'
import type { Icon } from 'shared/utils'

const ColdDrink = (props: Icon) => {
    const { color = 'black', size = 24, className = 'cold-drink' } = props
    return (
        <svg className={className} width={size} height={size} fill={color}>
            <path
                fillRule="evenodd"
                d="M17.364 8.764h-2.667l.472-5.064 1.925-.878a.417.417 0 0 0 .203-.574.417.417 0 0 0-.575-.202l-2.16.978c-.135.034-.237.203-.237.338l-.506 5.401H7.44a.447.447 0 0 0-.439.44c0 .235.203.438.439.438h.405l1.182 11.883c.033.236.203.405.439.405h6.042c.236 0 .405-.169.439-.405l1.18-11.884h.237a.447.447 0 0 0 .438-.439.447.447 0 0 0-.439-.438"
            />
        </svg>
    )
}

export { ColdDrink }
